'use client';

import Link from "next/link";
import Image from "next/image";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { doctorsData } from "@/data/doctors";
import { useTranslations } from "next-intl";

const DoctorsSection = () => {
  const t = useTranslations('doctors_section');

  return (
    <div className="container mt-16 grid gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
      {doctorsData.map((member) => {
        return (
          <div key={member.id} className="flex flex-col items-center">
            <div className="relative">
              <Avatar className="mb-4 size-40 overflow-hidden rounded-full border ring-1 ring-border md:mb-5 lg:size-48">
                <Image
                  src={`/images/doctors/${member.slug}.png`}
                  alt={t(`doctor_items.${member.slug}.name`)}
                  width={192}
                  height={192}
                  className="h-full w-full object-cover"
                />
                <AvatarFallback className="text-center text-xs">
                  {t(`doctor_items.${member.slug}.name`)}
                </AvatarFallback>
              </Avatar>
              <Link
                href={member.appointment_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group absolute right-2 top-2 inline-flex h-9 w-9 items-center justify-center rounded-full bg-accent-blue text-primary-foreground shadow hover:shadow-md transition"
                aria-label={`${t(`doctor_items.${member.slug}.name`)} — ${t('book_now')}`}
              >
                <FaRegCalendarCheck className="h-4 w-4" aria-hidden />
                <span className="sr-only">{t('book_now')}</span>
              </Link>
            </div>
            <p className="text-center font-medium">
              {t(`doctor_items.${member.slug}.name`)}
            </p>
            <p className="text-muted-foreground text-center text-sm">
              {t(`doctor_items.${member.slug}.specialty`)}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default DoctorsSection;
